export function allowedUserRol(
  rolesUsuario: string[],
  permisoMenu: readonly string[]
): boolean {
  return rolesUsuario.some((rol) => permisoMenu.includes(rol));
}
